const state = {
  listCategory: [],
  listCountry: [],
  listCity: [],
  listNeighborhood: [],
  listLevelExprerience: [],
  jobDetail: {},
  jobDetailNew: {}
}

export default state
